module.exports = __webpack_public_path__ + "img/2-2.f6b172e5.svg";